import { useTranslation } from "react-i18next";
import { ChevronDown, FileDown, Loader } from "@dreamhub/designsystem/icons";
import { Button } from "@/components/ui/button";
import IconContainer from "@/components/ui/icon-container";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import DropdownMenuListItem from "@/components/controls/OptionsDropdownMenu/DropdownMenuListItem";
import { ExportFormat } from "@/services/hooks/entities/useEntityExport";

interface ExportMenuProps {
  onExport: (format: ExportFormat) => void;
  isExporting: boolean;
  label: string;
  "data-test": string;
}

// Toolbar button that opens a CSV / Excel choice for the table's export. The
// trigger keeps the previous single-button look so toolbar layouts don't move;
// menu items carry the trigger's test id with a format suffix.
const ExportMenu: React.FC<ExportMenuProps> = ({
  onExport,
  isExporting,
  label,
  "data-test": dataTest
}) => {
  const { t } = useTranslation();
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          data-test={dataTest}
          variant="secondary"
          size="lg"
          className="h-8"
          disabled={isExporting}
        >
          <IconContainer>{isExporting ? <Loader /> : <FileDown />}</IconContainer>
          {label}
          <IconContainer>
            <ChevronDown />
          </IconContainer>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[12rem]">
        <DropdownMenuListItem
          option="csv"
          data-test={`${dataTest}-csv`}
          text={t("exportMenu.exportToCsv")}
          onSelect={() => onExport("csv")}
        />
        <DropdownMenuListItem
          option="xlsx"
          data-test={`${dataTest}-xlsx`}
          text={t("exportMenu.exportToExcel")}
          onSelect={() => onExport("xlsx")}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExportMenu;
